import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const WorkItem = ({ item }) => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/work/${item.id}`);
  };

  return (
    <div 
      className="relative cursor-pointer group"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleClick}
    >
      <div className="relative overflow-hidden rounded-2xl">
        {/* Image */}
        <div className="aspect-[4/3] overflow-hidden">
          <img 
            src={item.image_url} 
            alt={item.title}
            className={`w-full h-full object-cover transition-all duration-700 ${
              isHovered ? 'scale-110 brightness-50' : 'scale-100 brightness-100'
            }`}
          />
        </div>
        
        {/* Gradient Overlay */}
        <div 
          className={`absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent transition-opacity duration-300 ${
            isHovered ? 'opacity-100' : 'opacity-60'
          }`}
        />

        {/* Border Gradient */}
        <div 
          className="absolute inset-0 rounded-2xl transition-all duration-300"
          style={{
            border: isHovered ? `3px solid ${item.border_color}` : '3px solid transparent',
            boxShadow: isHovered ? `0 0 30px ${item.border_color}40` : 'none'
          }}
        />
        
        {/* Content */}
        <div className="absolute inset-0 flex flex-col justify-end p-8">
          <div className={`transition-all duration-500 ${
            isHovered ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'
          }`}>
            <div className="flex items-center gap-3 mb-3">
              <div 
                className="h-1 w-12 rounded-full transition-all duration-300"
                style={{ backgroundColor: item.border_color }}
              />
              <span className="text-gray-300 text-sm font-medium tracking-wider uppercase">
                {item.role}
              </span>
            </div>
          </div>

          <h3 className="text-white font-['Poppins'] text-3xl font-bold mb-4 leading-tight">
            {item.title}
          </h3>

          <div className={`flex items-center gap-2 text-white transition-all duration-500 ${
            isHovered ? 'translate-x-0 opacity-100' : '-translate-x-4 opacity-0'
          }`}>
            <span className="text-sm font-medium">View Project</span>
            <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-2" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkItem;